import qs from 'query-string';
import { generateShortUrl } from '@/share/api';
import {
    DownloadRecordRequest,
    IOperatePermissionKey,
    IRequestTeamCreate,
    IRequestTeamInvite,
    IResponseTeamCreate,
    IResponseTeamIdentity,
    IResponseTeamInvite,
    IResponseTeamMember,
    ITeamInfo,
    TeamInfoResponse,
    TeamMember,
} from '@/types/teamInfo';
import request from '@/utils/request';

// 多次请求合并成一次
const fetchTeamIdentityListResolveList: any[] = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/145971
 * [团队]可选身份列表
 */
export const fetchTeamIdentityList = () => {
    return new Promise<IResponseTeamIdentity>((resolve, reject) => {
        fetchTeamIdentityListResolveList.push(resolve);
        if (fetchTeamIdentityListResolveList.length === 1) {
            request
                .get<any, IResponseTeamIdentity>('/enterprise/identity_list', {
                    hiddenMessage: true,
                })
                .then((data) => {
                    // 处理个人设计师显示昵称
                    data.list.forEach((item) => {
                        if (!item.oid) {
                            item.alias = '个人设计师';
                        }
                    });
                    for (let i = 0; i < fetchTeamIdentityListResolveList.length; i++) {
                        const element = fetchTeamIdentityListResolveList[i];
                        element(data);
                    }
                    fetchTeamIdentityListResolveList.length = 0;
                    // console.log(
                    //   'fetchTeamIdentityList',
                    //   fetchTeamIdentityListResolveList.length,
                    // );
                })
                .catch((e) => {
                    fetchTeamIdentityListResolveList.length = 0;
                    reject(e);
                });
        }
    });
};

const fetchTeamMemberInfoResolveList: any[] = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/149033
 * [团队]获取我的成员信息
 */
export const fetchTeamMemberInfo = async () => {
    return new Promise<IResponseTeamMember>((resolve) => {
        fetchTeamMemberInfoResolveList.push(resolve);
        if (fetchTeamMemberInfoResolveList.length === 1) {
            request
                .get<any, IResponseTeamMember>('/enterprise/team/member_info', {
                    hiddenMessage: true,
                })
                .then((res) => {
                    for (let i = 0; i < fetchTeamMemberInfoResolveList.length; i++) {
                        const element = fetchTeamMemberInfoResolveList[i];
                        element(res);
                    }
                    fetchTeamMemberInfoResolveList.length = 0;
                });
        }
    });
};

/**
 * 团队信息
 * @returns
 */
export const fetchTeamAdminInfo = async function () {
    return await request.get<{}, TeamInfoResponse>('/enterprise/team/info', {});
};

/**
 * [团队]获取我成员列表
 */
export const fetchTeamMemberList = async () => {
    return await request.get<any, TeamMember[]>('/enterprise/team/member_list', {
        hiddenMessage: true,
    });
};

/**
 * [团队]创建团队 https://api-mock.meitu-int.com/project/2110/interface/api/145974
 * @param data
 * @returns
 */
export const createTeamApi = async (data: IRequestTeamCreate) => {
    return await request.post<any, IResponseTeamCreate>('/enterprise/team/create', qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
};

/** 复制个人版指定文件到团队版个人空间下 https://api-mock.meitu-int.com/project/2110/interface/api/163078 */
export const copyDirToMyTeamSpace = async ({
    current_node,
    node_id,
    oid,
}: {
    current_node: string;
    node_id: string;
    oid: number;
}) => {
    return await request.post<any, { current_node: string; id: string }>(
        '/yunpan/node/copy_to_my_space',
        qs.stringify({ current_node, id: node_id }),
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'client-ogroupid': oid,
                'client-oid': oid,
            },
        },
    );
};

/**
 * [团队]生成邀请码 https://api-mock.meitu-int.com/project/2110/interface/api/146100
 * @returns
 */
export const generateInvite = async ({
    teamInfo,
    entrance,
    ...data
}: IRequestTeamInvite & {
    entrance: string;
    teamInfo: ITeamInfo | null;
}): Promise<IResponseTeamInvite & { shortUrl: string }> => {
    const res = await request.post<any, IResponseTeamInvite>(
        '/enterprise/team/generate_inviate_key',
        qs.stringify(data),
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    );
    const identity = teamInfo?.identity.list.find((item) => item.oid === teamInfo.identity.oid);
    const parameter = `inviteKey=${res.invite_key}&channel=member_invite&trackMeta=${encodeURIComponent(
        JSON.stringify({
            uid: identity?.ouid ?? 'unknown',
            oid: identity?.oid ?? 'unknown',
            entrance,
        }),
    )}`;
    const { short_url } = await generateShortUrl({
        path: '',
        parameter,
    });
    return {
        ...res,
        shortUrl: short_url,
    };
};

/**
 * 接口 [上报下载资源↗](/common/sensitive_check)
 * https://api-mock.meitu-int.com/project/2110/interface/api/175621
 */
export const handleDownloadRecord = async function (data: DownloadRecordRequest) {
    return await request.post<{}>(`/zhanku/download_record`, qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
};

/**
 * [团队]获取我的权限
 * https://api-mock.meitu-int.com/project/2110/interface/api/146159
 */
export const fetchMemberPermission = () =>
    request.get<any, IOperatePermissionKey[]>('/enterprise/team/member_permissions', {
        hiddenMessage: true,
    });
